import { render, staticRenderFns } from "./ConnectionDetailDialog.vue?vue&type=template&id=36cbfee1"
import script from "./ConnectionDetailDialog.vue?vue&type=script&lang=js"
export * from "./ConnectionDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ConnectionDetailDialog.vue?vue&type=style&index=0&id=36cbfee1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports